export default "/_next/static/images/jason-kim-1723beaa81dd65b027570b78b0386ac3.png";